import { Navigation } from "@/components/layout/Navigation";
import { MatchBanner } from "@/components/sections/MatchBanner";
import { ErrorBoundary } from "@/components/ui/error-boundary";
import { useLocation } from "react-router-dom";
import { getAllCategoryPaths, LOCATION_PAGE_ROUTES } from "@/config/categoryRoutes";

// All hub/discovery page paths (Hitta*, WeddingLocations, ChurchesDiscovery)
const HUB_PATHS = Object.values(LOCATION_PAGE_ROUTES).map(p => `/${p}`);

export const Header = () => {
  const location = useLocation();
  
  // Get all category paths from central config
  const allCategoryPaths = getAllCategoryPaths();
  
  // Pages where MatchBanner should be hidden (hub pages, category pages + special pages)
  const excludedPaths = [
    ...HUB_PATHS,
    '/kyrkor',
    '/kyrkor/alla',
    '/gift/claim',
    '/supplier-profile',
    '/supplier-register',
    '/alla-vigselringar',
    // Add all category paths
    ...allCategoryPaths.map(path => `/${path}`),
  ];
  
  const decodedPathname = decodeURIComponent(location.pathname);
  const showMatchBanner = !excludedPaths.includes(decodedPathname) && 
    !decodedPathname.startsWith('/anslut-ditt-foretag') &&
    !decodedPathname.startsWith('/venue/') &&
    !decodedPathname.includes('/leverantor/') &&
    !decodedPathname.startsWith('/produkter/') &&
    !decodedPathname.startsWith('/my-conversations') &&
    !decodedPathname.startsWith('/supplier-conversations') &&
    !decodedPathname.startsWith('/supplier-conversation') &&
    !decodedPathname.startsWith('/verktyg') &&
    !decodedPathname.startsWith('/kyrkor') &&
    !decodedPathname.startsWith('/brollopstjanster/') &&
    !decodedPathname.startsWith('/annonsera-hos-oss');

  return (
    <header className="w-full h-auto relative">
      <div className="fixed top-0 inset-x-0 z-50">
        <ErrorBoundary>
          <Navigation />
        </ErrorBoundary>
      </div>
      <div className="h-[60px] sm:h-[68px] lg:h-[76px]" aria-hidden="true" />
      {showMatchBanner && (
        <ErrorBoundary>
          <MatchBanner />
        </ErrorBoundary>
      )}
    </header>
  );
};
